module.exports = __webpack_public_path__ + "img/logo_full.61547987.png";